// Play/Pause button on the public chart pages (ex PlayButton.vue). One sound
// plays at a time across the page, through window.soundEffect as before.
const SILENT_MP3 = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';

export const chartPlayerStore = { currentPlayingId: null };

const chartPlayButton = (soundId, audioUrl) => ({
    get playing() {
        return this.$store.chartPlayer.currentPlayingId === soundId;
    },
    toggle() {
        const store = this.$store.chartPlayer;
        if (store.currentPlayingId === soundId) {
            store.currentPlayingId = null;
            window.soundEffect.src = '';
            return;
        }
        store.currentPlayingId = soundId;
        if (window.soundEffect) {
            window.soundEffect.src = '';
        }
        window.soundEffect = new Audio();
        window.soundEffect.autoplay = true;
        window.soundEffect.src = SILENT_MP3;
        window.soundEffect.src = audioUrl;
    },
});

export default chartPlayButton;
